const GET_TYPES_OF_CONTRIBUTION_GROWTH_REQUEST = "spark/customer/insights/performance/sales/contributionGrowth/GET_TYPES_OF_CONTRIBUTION_GROWTH_REQUEST";
const GET_TYPES_OF_CONTRIBUTION_GROWTH_SUCCESS = "spark/customer/insights/performance/sales/contributionGrowth/GET_TYPES_OF_CONTRIBUTION_GROWTH_SUCCESS";
const GET_TYPES_OF_CONTRIBUTION_GROWTH_FAILURE = "spark/customer/insights/performance/sales/contributionGrowth/GET_TYPES_OF_CONTRIBUTION_GROWTH_FAILURE";

const types = {
    GET_TYPES_OF_CONTRIBUTION_GROWTH_REQUEST,
    GET_TYPES_OF_CONTRIBUTION_GROWTH_SUCCESS,
    GET_TYPES_OF_CONTRIBUTION_GROWTH_FAILURE
};

export default types;
